import React from 'react'
import { noLog as log } from 'web/src/shared/Utils'
import { PULLDOWN_REGIONS } from '@mote/helpers/constants'
import { FormInput } from './styles.common'

function hasRegions(countryCode) {
  return PULLDOWN_REGIONS[countryCode] && PULLDOWN_REGIONS[countryCode].items
}

function hasRegionName(countryCode) {
  return PULLDOWN_REGIONS[countryCode] && PULLDOWN_REGIONS[countryCode].name
}

function getRegionFieldName(cc) {
  if (cc && hasRegionName(cc)) {
    return PULLDOWN_REGIONS[cc].name
  } else {
    return 'State, province or county'
  }
}

function isValidRegion(cc, region) {
  log(`I was called with country [${cc}] and region [${region}]`)
  if (cc && hasRegions(cc)) {
    if (PULLDOWN_REGIONS[cc].items.includes(region)) {
      log("Yep, we're valid")
      return true
    } else {
      log('nope')
      return false
    }
  }
  if (region && region.length > 1) {
    log('we haz a region')
    return true
  }
  log('nope, no region')
  return false
}

const SmartRegion = ({ disabled, countryCode, region, onChange, ...rest }) => {
  const canSelectRegion = React.useMemo(
    () => !!hasRegions(countryCode),
    [countryCode]
  )
  const options = React.useMemo(() => {
    if (!canSelectRegion) return []

    return PULLDOWN_REGIONS[countryCode].items.map(value => ({
      value,
      text: value
    }))
  }, [canSelectRegion, countryCode])
  const placeholderValue = React.useMemo(() => {
    const regionFieldName = getRegionFieldName(countryCode)
    let text = 'Select country first'

    if (!disabled && canSelectRegion) text = `Select ${regionFieldName}`
    if (!disabled && !canSelectRegion) text = `Enter ${regionFieldName}`

    return text
  }, [countryCode, disabled, canSelectRegion])

  log(`render: region is: ${region}`)

  return (
    <FormInput
      label={getRegionFieldName(countryCode)}
      type={canSelectRegion ? 'select' : 'input'}
      options={options}
      disabled={disabled}
      placeholder={placeholderValue}
      // onChange={event => handleRegionChange(event.target.value)}
      {...rest}
    />
  )
}

export { SmartRegion, getRegionFieldName, isValidRegion }
